import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import API from '../../API';



async function postApi(data) {
    const apiUrl = API.baseURL + `/resend_otp?confirmation_token=${data}`;
    try {
        const response = axios.get(apiUrl, API.options)
        return await response;
    } catch (error) {
        throw error;
    }
}
function* resendOtp(action) {
    try {
        const response = yield call(postApi, action.data);
        if (response.status == 200 || response.status == 201) {
            yield put({ type: 'GET_REGISTER_RESEND_OTP_SUCCESS', data: response.data.message, message: 'OTP sent to your mobile successfully' });
        } else {
            const errorMessage = response.errors && response.errors.length != 0 ? response.errors[0] : 'Failed to send OTP';
            yield put({ type: 'GET_REGISTER_RESEND_OTP_FAILED', message: errorMessage });
        }
    } catch (e) {
        yield put({ type: 'GET_REGISTER_RESEND_OTP_FAILED', message: 'Unable to send OTP. Please try again.' });
    }
}

function* regResendOtpSaga() {
    yield takeEvery('GET_REGISTER_RESEND_OTP_REQUESTED', resendOtp);
}

export default regResendOtpSaga;